import theme from "Theme/AppTheme";

const border = `1px solid ${theme.palette.gray[200]}`;

export const tableContainerSx = {
    border,
    borderRadius: `${theme.shape.borderRadius * 2}px`,
    overflow: "hidden",
    backgroundColor: theme.palette.white.main,
};

export const tableHeaderSx = (columns: string) => ({
    display: "grid",
    gridTemplateColumns: columns,
    alignItems: "center",
    minHeight: 52,
    backgroundColor: theme.palette.gray[50],
    fontSize: 12,
    fontFamily: "Inter Bold",
    color: theme.palette.gray[600],
    "& > div": { paddingX: 2 },
});

export const tableRowSx = (columns: string) => ({
    display: "grid",
    gridTemplateColumns: columns,
    alignItems: "center",
    minHeight: 42,
    borderTop: border,
    fontSize: 12,
    color: theme.palette.gray[700],
    "& > div": {
        paddingX: 2,
        paddingY: 1.25,
        minWidth: 0,
        overflowWrap: "anywhere",
    },
});

export const tableMessageSx = {
    borderTop: border,
    paddingX: 2,
    paddingY: 2,
    fontSize: 12,
    color: theme.palette.gray[400],
};

export const tableFooterSx = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 3,
    minHeight: 52,
    paddingX: 2,
    borderTop: border,
    fontSize: 12,
    color: theme.palette.gray[600],
};
